import React from 'react';
import { Button } from '@roger/ui-components';
import { Download } from 'lucide-react';

interface ReportHeaderProps {
  title: string;
  description?: string;
  onExport?: () => void;
  isExporting?: boolean;
  exportDisabled?: boolean;
  exportLabel?: string;
}

export const ReportHeader: React.FC<ReportHeaderProps> = ({
  title,
  description,
  onExport,
  isExporting = false,
  exportDisabled = false,
  exportLabel = 'Export XLSX',
}) => {
  return (
    <div className='flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between'>
      <div>
        <h1 className='text-xl font-bold tracking-tight text-foreground'>
          {title}
        </h1>
        {description && (
          <p className='text-sm text-muted-foreground mt-0.5'>{description}</p>
        )}
      </div>
      {onExport && (
        <div className='flex items-center gap-2'>
          <Button
            variant='outline'
            size='sm'
            onClick={onExport}
            disabled={exportDisabled || isExporting}
          >
            <Download className='mr-1.5 h-4 w-4' />
            {isExporting ? 'Exporting…' : exportLabel}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ReportHeader;
